import React from 'react'
import { useTranslation } from 'react-i18next'
import { Col } from 'react-bootstrap'

import TextInput from 'components/ui/forms/field/text-input/TextInput'
import styles from './LikertQuestion.module.scss'
import { ILikerOptionModel } from 'models/questionLikert.model'

interface ILikertQuestion {
  data: ILikerOptionModel[]
  onChange?: any
}

const LikertQuestion: React.FC<ILikertQuestion> = ({ data, onChange }) => {
  const { t } = useTranslation()

  const handleChange = (label: string, index: number) => {
    const editedData = data.slice()
    editedData[index] = { ...editedData[index], label: label }
    onChange(editedData)
  }

  return <>{anwserList(5, data, handleChange, t)}</>
}

const anwserList = (
  howManyOptions: number,
  data: ILikerOptionModel[],
  handleChange: any,
  t: any
) => {
  const options: React.ReactElement[] = []
  for (let index = 0; index < howManyOptions; index++) {
    options.push(
      <Col
        lg={12}
        xl={7}
        key={'question' + index}
        className={'d-flex flex-row align-items-center mb-2'}
      >
        <div className={styles.questionLabel}>
          {' '}
          {`${t('administration.blocks.type.survey.question.option')} ${
            index + 1
          }`}
        </div>
        <TextInput
          name={'question' + index}
          placeHolder=""
          label=""
          value={data[index].label}
          onChange={(e) => handleChange(e.target.value, index)}
          error={''}
        />
      </Col>
    )
  }

  return options
}

export default LikertQuestion
